module.exports = __webpack_public_path__ + "img/img-2.9f8ef3eb.png";